import * as featureActions from './actions';
import { initialState, IUserStoreState } from './state';
import { createReducer, Action, ActionReducer, on, ReducerTypes } from '@ngrx/store';
import { withEntityReducer } from '@core-lib/store/entity-slice.function';

// declare our fully typed reducer
export function createUserReducer<A extends Action = Action>(
	initialState,
	...ons: ReducerTypes<IUserStoreState, any>[]
): ActionReducer<IUserStoreState, A> {
	return createReducer(initialState, ...ons);
}

const featureReducer = createUserReducer(
	initialState,

	...withEntityReducer<IUserStoreState>('user', featureActions.UserActions),
	...withEntityReducer<IUserStoreState>('usersTenant', featureActions.UsersTenantActions),
	...withEntityReducer<IUserStoreState>('carpas', featureActions.CarpasActions),
	...withEntityReducer<IUserStoreState>('currentCarpa', featureActions.CurrentCarpaActions),

	on(featureActions.resetUserState, (state, action) => initialState)
);

export function userStoreReducer(state: IUserStoreState, action: Action): IUserStoreState {
	return featureReducer(state, action);
}
